<style>
    #main-content{
        max-width: 980px;
    }
</style>

<script>
    var debounce = require('lodash.debounce');

    import listPreviewCard from '../lists/listPreviewCard';

    export default {
        props: ['lists'],
        components: {
            listPreviewCard
        },
        mixins: [],
        data: function () {
            return {
                product_lists: {
                    loading: false,
                    data: [],
                    search: '',
                    pagination: {
                        page: 1,
                        per_page: 40,
                    },
                    match_all_keywords: true,
                    load_more: true,
                    order_by: 'score',
                    order_dir: -1,
                },
            }
        },
        computed: {
            previous_page_url: function(){
                var page = this.product_lists.pagination.page;
                if(page <= 1){
                    return;
                }
                var url = window.location.origin + window.location.pathname;
                var url_obj = new URL(url);
                var search_params = url_obj.searchParams;
                search_params.set('page', page - 1);
                return url_obj.toString();
            },
            next_page_url: function(){
                var page = this.product_lists.pagination.page;
                var url = window.location.origin + window.location.pathname;
                var url_obj = new URL(url);
                var search_params = url_obj.searchParams;
                search_params.set('page', page + 1);
                return url_obj.toString();
            }
        },
        created: function () {
            if(this.lists){
                this.product_lists.data = this.lists;
            }

            this.initWithSearchParams();
        },
        mounted: function () {
            var self = this;


//            $(document).scroll(function () {
//                var el = $(this);
//                if (el.scrollTop() + window.innerHeight >= document.documentElement.scrollHeight - 900) {
//                    self.loadMoreProductLists();
//                }
//            });

        },
        methods: {
            initWithSearchParams: function(){
                var url_obj = new URL(window.location.href);
                var search_params = url_obj.searchParams;
                var page = search_params.get('page');
                if(search_params.get('page') !== null){
                    page = parseInt(page);
                    if(page > 1){
                        this.product_lists.pagination.page = page;
                    }
                }
                var search = search_params.get('q');
                if(search){
                    this.product_lists.search = search;
                }
            },
            getProductLists: function(page){
                var self = this;
                var search = this.product_lists.search.trim();
                if (this.product_lists.loading) {
                    return;
                }
                self.product_lists.loading = true;
                var url = '/api/v5/product-list';
                var params = {
                    search: search,
                    page: page || this.product_lists.pagination.page,
                    per_page: this.product_lists.pagination.per_page,
                    order_by: this.product_lists.order_by,
                };

                if(this.product_lists.min_price){
                    params.min_price = parseFloat(this.product_lists.min_price);
                }
                if(this.product_lists.max_price){
                    params.max_price = parseFloat(this.product_lists.max_price);
                }

                return axios.get(url, {params: params}).then(function (response) {
                    if(response.data.pagination){
                        self.product_lists.pagination.page = response.data.pagination.current_page;
                    } else if(page){
                        self.product_lists.pagination.page = page;
                    }
                    var data = response.data.data;
                    if (params.page === 1) {
                        self.product_lists.load_more = true;
                        self.product_lists.data = data;
                    } else {
//                        self.product_lists.data = self.product_lists.data.concat(data);
                        self.product_lists.data = data;
                    }

                    if(!data.length || data.length < params.per_page) {
                        self.product_lists.load_more = false;
                    }
                    if(response.data.pagination && params.page === response.data.pagination.last_page){
                        self.product_lists.load_more = false;
                    }

                    self.product_lists.loading = false;
                    $('html,body').animate({scrollTop:0});
                    self.updateUrl();

                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.product_lists.loading = false;
                });
            },
            searchProducts: function(){
                this.product_lists.pagination.page = 1;
                this.getProductLists();
            },
            debouncedSearch: debounce(function(){
                this.searchProducts();
            }, 500),
            loadMoreProductLists: function(){
                if(this.product_lists.loading || !this.product_lists.load_more){
                    return;
                }

                var page = this.product_lists.pagination.page + 1;
                this.getProductLists(page);
            },
            goToPreviousPage: function(event){
                event.preventDefault();
                if(this.product_lists.loading || !this.product_lists.load_more){
                    return;
                }

                var page = this.product_lists.pagination.page - 1;
                this.getProductLists(page);
            },
            goToNextPage: function(event){
                event.preventDefault();
                if(this.product_lists.loading || !this.product_lists.load_more){
                    return;
                }

                var page = this.product_lists.pagination.page + 1;
                this.getProductLists(page);
            },
            updateUrl: function(){
                var page = this.product_lists.pagination.page;
                var search = this.product_lists.search;
                var url_obj = new URL(window.location.href);
                var search_params = url_obj.searchParams;

                if(page > 1){
                    search_params.set('page', page);
                } else {
                    search_params.delete('page');
                }
                if(search){
                    search_params.set('q', search);
                } else {
                    search_params.delete('q');
                }
                history.replaceState({}, '', url_obj);
            }
        }
    };

</script>

<template>
    <div class="search-product-lists">
        <h1 class="style-page-title mb-4">Browse Product Lists</h1>
        <div class="form-outline form-group">
            <input type="text" class="form-control" placeholder=" " @input="debouncedSearch" v-model="product_lists.search">
            <label>Search</label>
        </div>
        <div v-if="product_lists.data.length">
            <div class="" v-for="(list, i) in product_lists.data" v-if="list.url && list.name && list.slug" :key="list.uuid">
                <list-preview-card :list="list"></list-preview-card>
                <hr>
            </div>
            <div class="row justify-content-between">
                <div class="col-auto">
                    <a :href="previous_page_url" class="btn btn-primary rounded-pill" v-if="previous_page_url" @click="goToPreviousPage" :disabled="product_lists.loading" style="min-width:140px">
                        <i class="fas fa-spin fa-spinner mr-1" v-if="product_lists.loading"></i>
                        Previous Page
                    </a>
                </div>
                <div class="col-auto">
                    <a :href="next_page_url" class="btn btn-primary rounded-pill" v-if="next_page_url" @click="goToNextPage" :disabled="product_lists.loading" style="min-width:140px">
                        <i class="fas fa-spin fa-spinner mr-1" v-if="product_lists.loading"></i>
                        Next Page
                    </a>
                </div>
            </div>
        </div>
        <div class="small" v-else>
            No lists found
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/lists/searchProductLists.vue